import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputFirstName: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="First Name:">
    {form.getFieldDecorator('firstName', {
      initialValue,
      rules: [{ required: false }],
    })(<Input allowClear placeholder="First Name" />)}
  </Form.Item>
);
